var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vue-content-loader",
    {
      attrs: {
        width: 1600,
        height: 160,
        speed: 2,
        "primary-color": "#f3f3f3",
        "secondary-color": "#ecebeb",
      },
    },
    [
      _c("rect", {
        attrs: {
          x: "810",
          y: "20",
          rx: "3",
          ry: "3",
          width: "67",
          height: "11",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "846",
          y: "38",
          rx: "3",
          ry: "3",
          width: "140",
          height: "11",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "814",
          y: "98",
          rx: "3",
          ry: "3",
          width: "53",
          height: "11",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "853",
          y: "80",
          rx: "3",
          ry: "3",
          width: "72",
          height: "11",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "747",
          y: "80",
          rx: "3",
          ry: "3",
          width: "100",
          height: "11",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "693",
          y: "38",
          rx: "3",
          ry: "3",
          width: "140",
          height: "11",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "753",
          y: "58",
          rx: "3",
          ry: "3",
          width: "173",
          height: "11",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }